export const dateConverter = (timestamp) => {
    const date = new Date(timestamp);
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const year = date.getFullYear();
    const month = monthNames[date.getMonth()];
    const day = date.getDate().toString().padStart(2, '0');

    return `${month} ${day}, ${year}`
}